import { useLocation, useNavigate } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { InvitationsPanel } from "@/components/settings/users/invitations-panel";
import { UsersPanel } from "@/components/settings/users/users-panel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

type Tab = "users" | "invitations";

export function SettingsUsersPage() {
  // Both /settings/users (default tab) and /settings/users/invitations are
  // mounted on this page so the admin can deep-link / bookmark the
  // invitations tab. The route uses a "*" splat so the page itself stays
  // mounted while in-page tab navigation just swaps the URL underneath it.
  const location = useLocation();
  const navigate = useNavigate();
  const trailing = location.pathname
    .replace(/^\/settings\/users\/?/, "")
    .split("/")[0];
  const active: Tab = trailing === "invitations" ? "invitations" : "users";

  const handleTabChange = (next: string) => {
    const target =
      next === "invitations" ? "/settings/users/invitations" : "/settings/users";
    navigate(target, { replace: true });
  };

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Workspace"
        title="User management"
        description="Invite people, change roles and status, reset 2FA, and revoke sessions."
      />

      <Tabs value={active} onValueChange={handleTabChange} className="space-y-4">
        <TabsList>
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="invitations">Invitations</TabsTrigger>
        </TabsList>
        <TabsContent value="users" className="mt-0">
          <UsersPanel />
        </TabsContent>
        <TabsContent value="invitations" className="mt-0">
          <InvitationsPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
